import AppPage from "layouts/AppPage";
import LinkCard from "components/Card/LinkCard";
import { Wrap, WrapItem } from "@chakra-ui/react";
import { MdTextFields } from "react-icons/md";
import { ADMIN_ROUTES } from "definitions/constants/routeConstants";
import useNavbar from "hooks/useNavbar";
import { useEffect } from "react";

const CUSTOM_INPUTS_LINKS = [
  {
    url: ADMIN_ROUTES.examples.floatingMd,
    label: "FloatingField — MD",
    description: "Floating label inputs at medium size",
    icon: MdTextFields,
  },
  {
    url: ADMIN_ROUTES.examples.floatingSm,
    label: "FloatingField — SM",
    description: "Floating label inputs at small size",
    icon: MdTextFields,
  },
];

export default function CustomInputsPage() {
  const { setPageTitle } = useNavbar();
  useEffect(() => {
    setPageTitle("Custom Inputs");
  }, [setPageTitle]);

  return (
    <AppPage>
      <Wrap width="100%" spacingX="4">
        {CUSTOM_INPUTS_LINKS.map(({ url, description, label, icon }) => (
          <WrapItem key={url} height="209px">
            <LinkCard target={{ url, description }} label={label} icon={icon} />
          </WrapItem>
        ))}
      </Wrap>
    </AppPage>
  );
}
